
<div 
    id="indicator" 
    :style="{ width: widthBar+'px', height: widthBar/5+'px', borderRadius: widthBar/10+'px'}"
    v-b-tooltip.hover :title="ratio + tooltip"
    ref="indicator"
>
    <div class="red_bar ind_bar left_50 border_left" ref="red">
    </div>
    <div class="green_bar ind_bar border_right" ref="green">
    </div>
    <div class="gray_bar ind_bar left_50 border_left" ref="gray_left">
    </div>
    <div class="gray_bar ind_bar border_right" ref="gray_right">
    </div>
    <div class="white_bar">
    </div>
</div>
